module.exports = __webpack_public_path__ + "img/punt_right.c68b0d88.jpg";